import React, { useEffect, useState } from "react";
import style from "./WalletLoadPopup.module.css";

import Close from "@mui/icons-material/Close";
import { toast, ToastContainer } from "react-toastify";
import { apiFormatPostFullCtrl } from "../../../../Api/ApiFormat";
import { serviceCheckMainFunc } from "../../../../Utils/activeServicesCheck";
import Popup from "../../../Commons/Popup/Popup";
import Select from "../../../Commons/Select/Select";
import WalletLoadIcon from "../../../../assets/images/wallet load.svg";
import { useNavigate } from "react-router-dom";

function WalletLoadPopup(props) {
  const [code, setCode] = useState("");
  const [popup, setPopup] = useState(false);
  const [ServiceMsg, setServiceMsg] = useState("");
  const navigate = useNavigate();

  const [data, setData] = useState({
    name: "",
    mobileNo: "",
    amount: "",
  });

  const opt = [
    { mode: "Debit Card", opCode: "PGDC" },
    { mode: "Credit Card", opCode: "PGCC" },
    { mode: "Corporate Credit Card", opCode: "PGCCC" },
    { mode: "Prepaid Card", opCode: "PGPPC" },
    { mode: "Net Banking", opCode: "PGNB" },
    { mode: "UPI", opCode: "PGUPI" },
  ];

  const onChangeHander = (e) => {
    let name = e.target.name;
    let val = e.target.value;

    if (name === "mobileNo") {
      if (val.length < 11) {
        setData({ ...data, [name]: val });
      }
    } else {
      setData({ ...data, [name]: val });
    }
  };

  //service check
  const ServiceChk = async () => {
    if ((await serviceCheckMainFunc("Wallet Load")) === "All good") {
      setServiceMsg("service is active");
    } else {
      setPopup(true);
      setServiceMsg("service is unactive");
    }
  };

  useEffect(() => {
    ServiceChk();
  }, []);

  //submit func
  const submitFunc = async () => {
    if (!data.name) {
      toast.error("Please enter your name!");
    } else if (!data.mobileNo) {
      toast.error("Please enter your mobile no. !");
    } else if (data.mobileNo.length !== 10) {
      toast.error("Mobile no. should be 10 digits!");
    } else if (!data.amount) {
      toast.error("Please enter your amount!");
    } else if (parseInt(data.amount) < 100 || parseInt(data.amount) > 100000) {
      toast.error("Amount limit is ₹100 to ₹1,00,000");
    } else if (!code) {
      toast.error("Please enter your code!");
    } else {
      let sendData = {
        Mobile: sessionStorage.getItem("retMobile"),
        Amount: data.amount,
        Name: data.name,
        CustMobileNo: data.mobileNo,
        Address: "Faridabad",
        RetUserId: sessionStorage.getItem("userId"),
        EmailId: "info@greenpaynetwork.co.in",
        PaymentMode: code,
        source: "DIST",
      };

      sessionStorage.setItem("walletLoadPaymentMode", code);
      const resp = await apiFormatPostFullCtrl(
        "/api/PaymenGatewayPayG/topupwalletV2",
        sendData
      );

      if (resp) {
        if (resp.data.errorCode === "200") {
          if (resp.data.data) {
            navigate("/distributor/PaymentGateWayRespV2/" + resp.data.data);
          } else {
            toast.error("Unable to generating wallet load link!");
          }
        } else {
          toast.error("Unable to generating wallet load link!");
        }
      } else {
        toast.error("Unable to generating wallet load link!");
      }
    }
  };
  return (
    <>
      {popup ? (
        <Popup
          head={"Service Status"}
          msg={"Service is not Active"}
          err={false ? "no" : "yes"}
          oKFunc={() => {
            props.close(false);
          }}
        />
      ) : (
        <div className="main_popup">
          <div className={`${style.card} main_popup_card`}>
            <div className={style.close}>
              {" "}
              <Close
                onClick={() => {
                  props.close(false);
                }}
                className={style.close_icon}
              />{" "}
            </div>
            <img src={WalletLoadIcon} width="57px" />
            <h1 className={style.head}>Wallet Load</h1>

            <div className={style.inputContainer}>
              <label>Name </label> <br />
              <input
                type={"text"}
                value={data.name}
                name={"name"}
                placeholder={"Enter your name"}
                onChange={onChangeHander}
              />
            </div>

            <div className={style.inputContainer}>
              <label>Mobile No. </label>
              <br />
              <input
                value={data.mobileNo}
                name={"mobileNo"}
                type={"number"}
                onWheel={(e) => e.target.blur()}
                placeholder={"Enter your Mobile No."}
                onChange={onChangeHander}
              />
            </div>

            <div className={style.inputContainer}>
              <label>Amount</label>
              <br />

              <input
                type={"number"}
                value={data.amount}
                name={"amount"}
                onWheel={(e) => e.target.blur()}
                placeholder={"Enter your Amount(₹)"}
                onChange={onChangeHander}
              />
            </div>

            <div className={style.inputContainer}>
              <label>Transaction Mode</label>
              <br />
              <Select
                menu={opt}
                setter={setCode}
                getField={"opCode"}
                howToAccess={"mode"}
                reset={""}
                defaultTxt={"--Select--"}
                style={{ marginTop: "-10px" }}
              />
            </div>

            <button
              className="primary_Btn"
              style={{ marginTop: "10px" }}
              onClick={submitFunc}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default WalletLoadPopup;
